import { h, Component } from 'preact'
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants';
import Opacity from './svg/Opacity';
import { DownOutlined } from '@ant-design/icons';

export default @connect(reduce, actions)
class OpacityWidget extends Component {
  constructor() {
    super()
  }

  render(props, state) {
    return (
      <div className="dropdown">
        {!props.isMobileVersion && <a className="dropdown-toggle icn rwd-icon hint--bottom" data-hint="Opacity">
          <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-opacity"} /></svg>
        </a>}
        {props.isMobileVersion && <a className="dropdown-toggle mobile-tool-widget">
          <Opacity/>
          <span>Opacity</span>
        </a>}
        <div className="dropdown-menu right" data-close="no">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Opacity</span>
            <div className="dropdown-toggle"><DownOutlined/></div>
          </div>}
          <div className="angle left"></div>
          <ul className="slider-list">
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Opacity</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="10" max="100" step="1" value={props.value} onChange={props.onUpdate} onMouseMove={props.onUpdate} />
                </div>
                <input className="value" type="number" min="10" max="100" step="1" disabled="disabled" value={Math.round(props.value)} />
              </div>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
